import { defineConfig, defineTokens } from "@chakra-ui/react";
import { ButtonStyles } from "./ButtonStyles";
import { ContainerStyles } from "./ContainerStyles";
import { HeadingStyles } from "./HeadingStyles";
import { InputStyles } from "./InputStyles";
import { SpinnerStyles } from "./SpinnerStyles";
import { sizes } from "./sizes";
import { LinkStyles } from "./LinkStyles";
import { colors } from "@biblioteksentralen/utils";

const tokens = defineTokens({
  sizes,
});

// https://blog.logrocket.com/guide-css-word-wrap-overflow-wrap-word-break/
// https://medium.com/clear-left-thinking/all-you-need-to-know-about-hyphenation-in-css-2baee2d89179
// Skrur på hyphens auto som default fordi vi har masse mikrotekster og små elementer der layout knekker uten dette, og vi lager stadig nye og glemmer å ta hensyn til dette.
// Så kan man optionaly sette hyphens: none de stedene man ikke ønsker det, men har ikke sett noe som knekker/blir rart pga dette enda
const globalHyphens = {
  hyphens: "auto",
  hyphenateLimitChars: "8 5 3", // minimum word-length / min letters first line / min letters second line
};

export const focusStyle = {
  outline: "none !important",
  boxShadow: `0 0 0 .05rem ${colors.white}, 0 0 0 .25rem ${colors.accentBlueMedium}, 0 0 0 .3rem ${colors.white} !important`,
  transition: "box-shadow 0.1s ease-out", // Transition makes the newly focused element "pop in" and easier to spot
};

export const biblioteksentralenChakraTheme = defineConfig({
  theme: {
    tokens,
    recipes: {
      heading: HeadingStyles,
      button: ButtonStyles,
      input: InputStyles,
      link: LinkStyles,
      container: ContainerStyles,
      spinner: SpinnerStyles,
    },
  },
  globalCss: {
    html: {
      fontSize: { base: "112.5%", md: "120%" },
      // Sørger for smooth scrolling for interne lenker som scroller til annet sted på siden,
      // men ikke hvis fokus er utenfor viduet, feks ved søk i tekst (ctrl + f)
      "&:focus-within": { scrollBehavior: "smooth !important" },
    },
    body: {
      ...globalHyphens,
    },
    // Felles fokus-styling for alle elementer for å sikre at de har en tydelig og uniform visuell indikasjon når de er i fokus
    "*:focus-visible": focusStyle,
  },
});
